<template>
	<div class="report-form">
		<ReportFormHeader></ReportFormHeader>
		<div class="report-form-body">
			<SettingMenu
				ref="settingMenu"
				:visible.sync="settingMenuVisible"
				:colData.sync="gridCol"
				:settingCols="settingCols"
				:reportid="reportid"
				:widthArr='widthArr'
				:planSelect.sync="planSelect"
				:planOptions="planOptions"
				@planChange='planChange'
				@updataCol='updataCol'
				@getWidth='getWidth'
				@changeShowColData="changeShowColData"
				@changeFrozenColData="changeFrozenColData"
				@savePlanResolve="savePlanResolveHandler">
			</SettingMenu>
			<div class="report-form-wrap">
				<FiltersComp :settingMenuVisible="settingMenuVisible" :reportid="reportid" :gridCol.sync="gridCol" :reportName="reportName" @memuClick="settingMenuClickHandler" @searchClick="searchHandler" @clearSearchClick='clearSearchHandler' class="clearfix">
					<slot name="filters" slot="filters"></slot>
				</FiltersComp>
				<ToolsBox :reportName="reportName" @exportExcle="exportHandker"></ToolsBox>
				<GridComp
					ref="gridComp"
					v-bind="$attrs"
					:reportName="reportName"
					:detailType="detailType"
					:gridCol.sync="gridCol"
					:gridData="gridData"
					:tableData='tableData'
					:pieData="pieData"
					:getCustomThroughParams="getCustomThroughParams"
					:sumCol="sumCol"
					:sumdata="sumdata"
					@loadmore='loadMore'
					@sort-change="sortChangeHandle">
				</GridComp>
				<el-dialog class="confirm-dialog2" top='160px' :visible.sync="progressModal" width='400px' :close-on-click-modal="false">
					<Progress
						ref="progress"
						:progressModal.sync='progressModal'
						v-if='progressModal'
						:keyWord='keyWord'
						:reportUrl='reportUrl'
						:percentage='percentage'
					></Progress>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * getCustomThroughParams 返回array,数组每个值为一个object
 * object param:
 * @param {field} [String] - 字段名称
 * @param {op} [String] - 规则
 * @param {type} [String] - 参数类型 [cParams / filtersParams]
 */
import { mapState } from 'vuex'
import { unzip } from '@/js/lib/pako'
import SettingMenu from '@/components/reportform/common/SettingMenuNew.vue'
import ReportFormHeader from '@/components/reportform/common/ReportFormHeader.vue'
import FiltersComp from '@/components/reportform/common/FiltersComp.vue'
import ToolsBox from '@/components/reportform/common/ToolsBox.vue'
import GridComp from '@/components/reportform/common/GridCompNew.vue'
import Progress from '@/components/progress/report.vue'
export default {
	name: 'reportFormWrap',
	components: {
		SettingMenu,
		ReportFormHeader,
		FiltersComp,
		ToolsBox,
		GridComp,
		Progress
	},
	props: {
		reportid: String,
		reportFormUrl: String,
		reportName: String,
		detailType: String,
		settingCols: {
			type: Array,
			default: () => []
		},
		getFiltersParams: {
			type: Function,
			default: () => {}
		},
		getCustomThroughParams: Function,
		orderMenu: {
			type: Array,
			default: () => {
				return []
			}
		},
		zipFlag: {
			type: Boolean,
			default: () => false
		},
		initFilters: {
			type: Function,
			default: () => {}
		},
		customSaleNewSearchParams: {
			type: Object,
			default: () => {}
		}
	},
	data () {
		return {
			paramsRow: 0,
			progressModal: false,
			percentage: 0,
			timer: null,
			widthArr: [],
			page: 1,
			isMore: true,
			isLoad: false,
			settingMenuVisible: false,
			gridData: [],
			sumCol: {},
			gridCol: [],
			planSelect: null,
			planOptions: [],
			currentReport: {},
			bigcategoryview: 0,
			matchbillcenterflag: 1,
			tableData: [],
			reportId: '',
			keyWord: '',
			reportUrl: '',
			sumdata: {
				orderidcount: 0,
				livequantity: 0,
				livemoney: 0,
				refundidcount: 0,
				refundquantity: 0,
				refundmoney: 0,
				unproductsalecount: 0
			},
			pieData: [{
				name: '暂无数据',
				nameDot: '暂无数据',
				value: 0
			}]
		}
	},
	created () {
		this.setVuexData()
		this.checkSmallCategory()
		var arr = []
		this.settingCols.forEach(item => {
			if (item.ischoose) {
				item.showFlag = true
			}
			item.fixed = false
			if (this.bigcategoryview === 1) {
				if (item.prop !== 'smallcategoryname' && item.prop !== 'smallCategoryName') {
					arr.push(item)
				}
			} else {
				arr.push(item)
			}
		})
		this.gridCol = JSON.parse(JSON.stringify(arr))
		this.$nextTick(() => {
			this.$refs.gridComp.drawPie()
		})
	},
	computed: {
		...mapState([
			'orderName',
			'searchParams'
		])
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		planChange () {
			this.$refs.gridComp.headerDragend()
		},
		updataCol (data) {
			// console.log(data)
			this.gridCol = data
		},
		getWidth (callback) {
			let arr = this.$refs.gridComp.getWidth()
			callback(arr)
		},
		loadMore () {
			if (this.isMore && !this.isLoad) {
				this.isLoad = true
				this.page++
				this.isMore = this.page * 50 < this.gridData.length
				let data = JSON.parse(JSON.stringify(this.gridData))
				let arr = data.splice((this.page - 1) * 50, 50)
				this.tableData = this.tableData.concat(arr)
				data = null
				this.isLoad = false
			}
		},
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
				this.matchbillcenterflag = res.matchbillcenterflag
			})
		},
		setVuexData () {
			let currentReport = this.orderMenu.find(item => {
				// return this.reportid === item.key
				return item.key.indexOf(this.reportid) !== -1
			})
			this.currentReport = currentReport
			this.$store.commit({
				type: 'SETSTATE',
				orderType: currentReport.orderType,
				reportid: currentReport.key,
				orderName: currentReport.label,
				throughPath: currentReport.throughPath,
				throughParams: currentReport.throughParams,
				orderMenu: this.orderMenu
			})
		},
		// 暂时取消方案功能
		initReportForm () {
			return new Promise(resolve => {
				this.initPlan().then(() => {
					if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
						this.throughHandler().then(() => {
							resolve()
						})
					} else if (this.reportName === 'customSaleNew' && !this.$fxUtils.isEmptyObjSHW(this.customSaleNewSearchParams)) {
						this.initFilters()
						this.searchFunc(this.customSaleNewSearchParams).then(() => {
							resolve()
						})
					} else {
						resolve()
					}
				})
			})
		},
		// initReportForm () {
		// 	return new Promise(resolve => {
		// 		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
		// 			this.throughHandler().then(() => {
		// 				resolve()
		// 			})
		// 		} else {
		// 			resolve()
		// 		}
		// 	})
		// },
		initPlan () {
			return new Promise(resolve => {
				this.getFormPlan().then(res => {
					this.setDefaultPlan(res).then(() => {
						resolve()
					})
				})
			})
		},
		getFormPlan () {
			return new Promise(resolve => {
				let param = {
					reportid: this.reportid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/reportScheme/getReportScheme`,
					data: param
				}).then(res => {
					resolve(res.data)
				}, () => {
					resolve([])
				})
			})
		},
		setDefaultPlan (planArr = []) {
			return new Promise(resolve => {
				if (planArr.length > 0 && planArr[0] && planArr[0].defaultflag) {
					this.planSelect = planArr[0].id
				} else {
					this.planSelect = null
				}
				this.planOptions = planArr
				this.$nextTick(() => {
					resolve()
				})
			})
		},
		settingMenuClickHandler () {
			this.settingMenuVisible = !this.settingMenuVisible
		},
		getThroughParams () {
			let params = decodeURI(this.$route.query.throughParams)
			let throughParams = this.$fxUtils.JSONparse(params, 'object')
			let filtersParamsObj = {
				filtersParams: [],
				cParams: []
			}
			for (let key in throughParams) {
				let obj = { 'field': throughParams[key].field, 'data': throughParams[key].value, 'op': throughParams[key].op }
				filtersParamsObj[throughParams[key].type].push(obj)
			}
			// console.log(filtersParamsObj)
			return filtersParamsObj
		},
		throughHandler () {
			return new Promise(resolve => {
				let filtersParamsObj = this.getThroughParams()
				this.searchFunc(filtersParamsObj).then(() => {
					resolve()
				})
			})
		},
		clearSearchHandler () {
			this.$emit('clearSearchClick')
		},
		searchHandler () {
			return new Promise(resolve => {
				let filtersParamsObj = this.getFiltersParams()
				if (this.reportName === 'customSaleNew') {
					window.localStorage.setItem('customSaleNewSearchParams', JSON.stringify(filtersParamsObj))
				}
				// console.log(filtersParamsObj)
				if (this.reportName === 'goodMarketNew' || this.reportName === 'goodCustomDetail') {
					var begintime = filtersParamsObj.filtersParams[0].data
					var endtime = filtersParamsObj.filtersParams[1].data
					// 判断时间跨度是否大于12个月
					var arr1 = begintime.split('-')
					var arr2 = endtime.split('-')
					arr1[1] = parseInt(arr1[1])
					arr1[2] = parseInt(arr1[2])
					arr2[1] = parseInt(arr2[1])
					arr2[2] = parseInt(arr2[2])
					var type = true
					if (arr2[0] - arr1[0] > 1) {
						type = false
					} else if (arr2[0] - arr1[0] === 1) {
						if (arr1[1] < arr2[1]) { // 月相隔大于12个月
							type = false
						} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
							if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
								type = false
							}
						}
					}
					// }
					if (!type) {
						this.$message.error('时间范围不得超过12个月！')
						return false
					}
				}
				if (this.orderName !== '单据支付对账明细表' && this.orderName !== '支付流水报表') {
					if (filtersParamsObj.filtersParams.length === 0) {
						this.$message.error('至少选择一个时间段')
						return false
					}
					for (let i = 0; i < filtersParamsObj.filtersParams.length; i++) {
						let e = filtersParamsObj.filtersParams[i]
						if (e.data.indexOf('undefined') !== -1 && e.name === '下单时间') {
							this.$message.error(e.name + '不可为空！')
							return false
						}
					}
				} else {
					let flag = false
					for (let i = 0; i < filtersParamsObj.filtersParams.length; i++) {
						let e = filtersParamsObj.filtersParams[i]
						if (e.name === '下单时间' || e.name === '支付时间' || e.name === '退款时间') {
							if (e.data.indexOf('undefined') === -1) {
								flag = true
							}
						}
					}
					if (!flag) {
						this.$message.error('至少选择一个时间段')
						return false
					}
				}
				this.searchFunc(filtersParamsObj).then(() => {
					resolve()
				})
			})
		},
		searchFunc (filtersParamsObj = {}) {
			return new Promise(resolve => {
				this.keyWord = 'search'
				this.progressModal = true
				this.page = 1
				this.isLoad = false
				this.isMore = true
				let settingMenuParams = this.settingCols.map(item => {
					return item.prop
				})
				let settingMenuLabel = this.settingCols.map(item => {
					return item.label
				})
				let excelCol = this.$refs.gridComp.getCurrentCols().filter(item => {
					return item.showFlag === true
				})
				excelCol = excelCol.filter(item => item.fixed === true).concat(excelCol.filter(item => item.fixed === false))
				let showcols = excelCol.map(item => {
					if (item.showFlag) {
						return item.prop
					}
				})
				let param = {
					filters: { 'rules': filtersParamsObj.filtersParams },
					c: filtersParamsObj.cParams,
					_search: true,
					rows: 30,
					page: 1,
					validcols: settingMenuParams.join(','),
					colsCN: settingMenuLabel.join(','),
					reportId: this.reportId,
					showcols: showcols.join(',')
				}
				this.$store.commit({
					type: 'SETSTATE',
					searchParams: param
				})
				this.$store.dispatch('requestFilePost', {
					url: this.reportFormUrl,
					data: param,
					loading: false
				}).always(res => {
					this.$refs.progress.percentage = 100
					// let unzipRes = JSON.parse(unzip(res))
					let unzipRes = ''
					let tableData = []
					let handleData = []
					if (this.zipFlag) {
						unzipRes = JSON.parse(unzip(res))
						handleData = typeof unzipRes.rows === 'number' ? unzipRes.currentData : unzipRes.rows
						tableData = JSON.parse(JSON.stringify(handleData))
					} else {
						unzipRes = res
						handleData = typeof unzipRes.rows === 'number' ? unzipRes.currentData : unzipRes.rows
						tableData = JSON.parse(JSON.stringify(handleData))
					}
					console.log(unzipRes)
					this.reportId = unzipRes.reportId
					this.paramsRow = tableData.length
					this.setGridData(unzipRes)
					// this.tableData = tableData.splice(0, 50)
					this.tableData = tableData
					let emptySum = {
						orderidcount: 0,
						livequantity: 0,
						livemoney: 0,
						refundidcount: 0,
						refundquantity: 0,
						refundmoney: 0
					}
					this.sumdata = unzipRes.sumdata ? unzipRes.sumdata : emptySum
					tableData.forEach((item, index) => {
						// item.name = `${item.pname} 【规格:${item.spec}】`
						if (this.reportName === 'goodMarketNew' || this.reportName === 'customGoodDetail') {
							let spec = item.spec ? `【规格:${item.spec}】` : ''
							item.name = `${index + 1}、${item.pname} ${spec}`
							item.value = item.livequantity
						}
						if (this.reportName === 'goodCustomDetail' || this.reportName === 'orderCustomDetail') {
							let customercategoryname = item.customercategoryname ? `【客户类别:${item.customercategoryname}】` : ''
							item.name = `${index + 1}、${item.customername} ${customercategoryname}`
							item.value = item.livequantity
						}
						if (this.reportName === 'customSaleNew') {
							let customercategoryname = item.customercategoryname ? `【客户类别:${item.customercategoryname}】` : ''
							item.name = `${index + 1}、${item.customerName} ${customercategoryname}`
							item.value = item.livemoney
						}
						item.nameDot = item.name.length > 16 ? item.name.slice(0, 16) + '...' : item.name
					})
					if (tableData.length === 0) {
						let noData = [{
							name: '暂无数据',
							nameDot: '暂无数据',
							value: 0
						}]
						this.pieData = noData
					} else if (tableData.length >= 20) {
						let cloneVal = this.$fxUtils.deepClone(tableData)
						let frontData = cloneVal.splice(0, 19)
						let behindValue = 0
						if (this.detailType !== 'unorder') {
							behindValue = cloneVal.map(item => {
								if (this.reportName === 'goodMarketNew' || this.reportName === 'goodCustomDetail' || this.reportName === 'customGoodDetail') {
									return item.livequantity
								}
								if (this.reportName === 'customSaleNew') {
									return item.livemoney
								}
							}).reduce((pre, cur) => {
								return pre + cur
							})
							behindValue = behindValue.toString().indexOf('.') === -1 ? behindValue : this.$fxUtils.toFixedSHW(behindValue, 2)
						}
						let behindData = {
							name: '20、其他',
							nameDot: '20、其他',
							value: behindValue || 0
						}
						frontData.push(behindData)
						this.pieData = frontData
					} else {
						this.pieData = tableData
					}
					this.$nextTick(() => {
						this.$refs.gridComp.drawPie()
					})
					tableData = null
					// if (unzipRes.warn) {
					// 	this.$message.warning(unzipRes.warn)
					// }
					resolve()
				})
			})
		},
		setGridData (gridObj = { rows: [], userdata: {} }) {
			this.gridData = Object.freeze((typeof gridObj.rows === 'number' ? gridObj.currentData : gridObj.rows) || [])
			this.sumCol = gridObj.userdata || {}
		},
		exportHandker () {
			if (this.$fxUtils.isEmptyObjSHW(this.searchParams)) {
				this.$message({
					message: '请先点击查询按钮后，再进行导出数据操作！',
					type: 'error'
				})
				return false
			}
			let excelCol = this.$refs.gridComp.getCurrentCols().filter(item => {
				return item.showFlag === true
			})
			excelCol = excelCol.filter(item => item.fixed === true).concat(excelCol.filter(item => item.fixed === false))
			let excelSumCol = this.$refs.gridComp.getSumCols()
			// 导出修改  只改主订单明细对账表
			if (this.orderName === '主订单明细对账表') {
				this.keyWord = 'export'
				this.progressModal = true
				this.exportLoop()
			} else {
				let exportName = this.orderName
				if (this.reportName === 'goodMarketNew' || this.reportName === 'goodCustomDetail') {
					let filtersParamsObj = this.getFiltersParams()
					let begintime = filtersParamsObj.filtersParams[0].data
					let endtime = filtersParamsObj.filtersParams[1].data
					exportName = `${this.orderName}（${begintime}～${endtime}）`
					if (this.reportName === 'goodCustomDetail') {
						exportName = `${this.orderName}_客户明细（${begintime}～${endtime}）`
					}
				}
				console.log(this.orderName, excelCol, this.gridData, excelSumCol)
				this.$fxExcel.exportExcel({
					excelTitle: exportName,
					excelCol,
					excelData: this.gridData,
					excelSumCol
				})
			}
		},
		exportLoop () {
			this.timer = setTimeout(() => {
				let params = this.searchParams
				let excelCol = this.$refs.gridComp.getCurrentCols().filter(item => {
					return item.showFlag === true
				})
				excelCol = excelCol.filter(item => item.fixed === true).concat(excelCol.filter(item => item.fixed === false))
				let showcols = excelCol.map(item => {
					if (item.showFlag) {
						return item.prop
					}
				})
				params.showcols = showcols.join(',')
				params.rows = this.paramsRow
				params.reportId = this.reportId
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.newExportUrl}/orderDetail`,
					data: params
				}).then(res => {
					if (!res.result) {
						this.progressModal = false
						clearInterval(this.timer)
						this.timer = null
						return false
					}
					if (res.data.url) {
						clearInterval(this.timer)
						this.timer = null
						if (res.data.url.indexOf('http') !== -1) {
							this.reportUrl = res.data.url
						} else {
							this.reportUrl = 'https://' + location.host + res.data.url
						}
						this.$refs.progress.percentage = 100
					} else {
						this.reportId = res.data.reportId
						this.exportLoop()
					}
				}).catch(err => {
					console.log(err)
					this.progressModal = false
					clearInterval(this.timer)
					this.timer = null
				})
			}, 1000)
		},
		getExcelCol () {
			let excelCol = this.gridCol.filter(item => {
				return item.showFlag === true
			})
			let frozencols = excelCol.filter(item => {
				return item.fixed === true
			})
			let normalcols = excelCol.filter(item => {
				return item.fixed !== true
			})
			excelCol = frozencols.concat(normalcols)
			return excelCol
		},
		changeShowColData ([checkArr, empty2full]) {
			this.gridCol = this.gridCol.map(item => {
				if (checkArr.includes(item.prop)) {
					item.showFlag = true
				} else {
					item.showFlag = false
				}
				return item
			})
			// if (empty2full) {
			// 	this.searchHandler()
			// }
		},
		changeFrozenColData ([checkArr, empty2full]) {
			this.gridCol = this.gridCol.map(item => {
				if (checkArr.includes(item.prop)) {
					item.fixed = true
				} else {
					item.fixed = false
				}
				return item
			})
			// if (empty2full) {
			// 	this.searchHandler()
			// }
		},
		savePlanResolveHandler () {
			this.getFormPlan().then(res => {
				this.planOptions = res
			})
		},
		sortChangeHandle ({ column, prop, order }) {
			console.log(column, prop, order, this.$refs.gridComp.$refs.table.tableData)
			let tableData = this.$refs.gridComp.$refs.table.tableData
			if (tableData.length > 0) {
				tableData.forEach(item => {
					item.value = item[prop]
				})
				if (tableData.length >= 20) {
					let cloneVal = this.$fxUtils.deepClone(tableData)
					let frontData = cloneVal.splice(0, 19)
					let behindValue = cloneVal.map(item => {
						return item[prop]
					}).reduce((pre, cur) => {
						return pre + cur
					})
					let behindData = {
						name: '20、其他',
						nameDot: '20、其他',
						value: behindValue
					}
					frontData.push(behindData)
					this.pieData = frontData
				} else {
					this.pieData = tableData
				}
				this.$nextTick(() => {
					this.$refs.gridComp.drawPie()
				})
			}
			// if (this.gridData.length < 2) {
			// 	return false
			// }
			// let param = this.searchParams
			// param.c = this.getFiltersParams().cParams
			// param = Object.assign(this.searchParams, {
			// 	sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			// 	sidx: prop
			// })
			// this.$store.dispatch('requestFilePost', {
			// 	url: this.reportFormUrl,
			// 	data: param
			// }).always(res => {
			// 	this.tableData = []
			// 	this.isMore = true
			// 	this.page = 1
			// 	let unzipRes = JSON.parse(unzip(res))
			// 	// setTimeout(() => {
			// 	let tableData = JSON.parse(JSON.stringify(unzipRes.rows))
			// 	this.setGridData(unzipRes)
			// 	this.tableData = tableData.splice(0, 50)
			// 	tableData = null
			// 	if (unzipRes.warn) {
			// 		this.$message.warning(unzipRes.warn)
			// 	}
			// 	// }, 500)
			// })
		}
	}
}
</script>
<style lang="stylus" scoped>
.report-form {
	background-color:#fff
	width:100%;
	display: flex;
	flex-direction: column
	.report-form-body {
		position:relative;
		overflow-y :hidden;
		flex: 1;
		display: flex;
		flex-direction: row
	}
	.report-form-wrap {
		flex-shrink: 0;
		width: 100%;
		flex: 1;
		overflow-x: hidden;
		display: flex
		flex-direction: column;
		height: 100%;
	}
}
</style>
<style lang="stylus">
.confirm-dialog2{
	.el-dialog__header{
		display: none
	}
}
</style>
